import { render, staticRenderFns } from "./Passaporte.vue?vue&type=template&id=250e6fd4"
import script from "./Passaporte.vue?vue&type=script&lang=js"
export * from "./Passaporte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports